import React from 'react';
import logo from '../img/logo.png';

// Friendly full-page error screen shared by the app error boundary and the
// router's errorElement. Never shows stack traces or technical details.
function ErrorScreen({
  title = 'Something went wrong on our side',
  message = "Don't worry — your information is safe. Please refresh the page to try again. If it still doesn't work, go back to the home page and try once more.",
}) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-[#f2ece9] p-5">
      <section className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-7 text-center shadow-xl sm:p-10">
        <img src={logo} alt="Rize Mortgage" className="mx-auto mb-7 h-auto w-36" />
        <div className="mx-auto mb-5 flex h-12 w-12 items-center justify-center rounded-full bg-red-50 text-red-600" aria-hidden="true">
          <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v3m0 4h.01M10.3 4.4 2.7 18a2 2 0 0 0 1.75 3h15.1a2 2 0 0 0 1.75-3L13.7 4.4a2 2 0 0 0-3.4 0Z" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-[#0a1445]">{title}</h1>
        <p className="mt-3 text-sm leading-6 text-slate-600">{message}</p>
        <div className="mt-7 flex flex-col-reverse justify-center gap-3 sm:flex-row">
          <a href="/" className="rounded-xl border border-slate-300 px-5 py-3 text-sm font-semibold text-[#211b4f] transition hover:bg-slate-50">Back to home</a>
          <button type="button" onClick={() => window.location.reload()} className="rounded-xl bg-[#fb6635] px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#e95627]">Try again</button>
        </div>
      </section>
    </main>
  );
}

export default ErrorScreen;
